
<!--
fileName : static配下の格納したファイル名を渡す
index: オブジェクトのキーを取得する
-->
<template>
    <div
      @click="setDiseaseIndex"
      class="stamp"
    >
        <img :src="loadImg" :alt="index" class="stamp-icon" :class="diseaseName.toLowerCase()">
        <div v-text="label" :class="`text-${diseaseName.toLowerCase()}`" />
    </div>
</template>

<script>
import VueTypes from "vue-types";

export default {
    props: {
        diseaseName: VueTypes.string.isRequired,
        index: VueTypes.string.isRequired,
        onOff: VueTypes.bool.isRequired
    },
    computed: {
        loadImg() {
          if (this.onOff) {
            return require(`../../../../static/svg/btn_${this.diseaseName.toLowerCase()}_on.svg`)
          } else {
            return require(`../../../../static/svg/btn_${this.diseaseName.toLowerCase()}_off.svg`)
          }
        },
        label() {
          return this.$store.state.labels.diseaseNames[this.diseaseName]
        }
    },
    methods: {
        setDiseaseIndex () {
            this.$emit('setDiseaseIndex', this.index)
        }
    }
}
</script>

<style scoped>
  .spamp {
    box-sizing: border-box;
  }
  .stamp:hover {
    cursor: pointer;
  }
  .stamp-icon {
      width: 50px;
      height: 50px;
  }
  .prostate {
    width: 35px;
    height: 35px;
    margin-top: 10px;
  }
  .text-prostate {
    margin-top: 5px;
  }
</style>
